import(/* webpackMode: "eager" */ "/var/www/voiceagent-app/RestroAgent/src/app/(landing)/cookie/page.tsx");
